import { render, staticRenderFns } from "./ClaimGasSuccessStep.vue?vue&type=template&id=3ccca110&scoped=true"
import script from "./ClaimGasSuccessStep.vue?vue&type=script&lang=ts"
export * from "./ClaimGasSuccessStep.vue?vue&type=script&lang=ts"
import style0 from "./ClaimGasSuccessStep.vue?vue&type=style&index=0&id=3ccca110&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ccca110",
  null
  
)

export default component.exports